import React, { Component, type ErrorInfo, type ReactNode } from 'react'
import { Box, Typography, Container } from '@mui/material'
import { ReactComponent as Bug } from '../assets/bug.svg'
import GenericButton from './GenericButton'
import { ButtonSize, ButtonType } from './GenericButton/styles'
interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError (): State {
    return { hasError: true }
  }

  componentDidCatch (error: Error, errorInfo: ErrorInfo): void {
    console.error('Error caught by ErrorBoundary:', error, errorInfo)
  }

  handleReload = (): void => {
    window.location.reload()
  }

  goToHomePage = (): void => {
    window.location.href = '/'
  }

  render (): ReactNode {
    if (this.state.hasError) {
      return (
                <Container maxWidth="sm" sx={{ height: '100vh', mt: -10, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

                    <Bug width={'300px'} height={'300px'} />
                    <Typography variant="h4" >
                        Oops!!!
                    </Typography>
                    <Typography variant="h5" my={2} >
                        Something Went Wrong!
                    </Typography>
                    <Typography fontSize={'18px'} >
                        We are having trouble loading this page. Please try again.
                    </Typography>
                    <Box display={'flex'} gap={2} mt={3}>
                        <GenericButton style={{ borderRadius: '6px' }} label='Go to Homepage' buttonType={ButtonType.Primary} onClick={this.goToHomePage} />
                        <GenericButton style={{ borderRadius: '6px' }} label='Reload Page' buttonType={ButtonType.Secondary} onClick={this.handleReload} />
                    </Box>
                </Container>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
